function SendEmailConfirmationIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16.001"
      height="16"
      data-name="SendEmailConfirmationIcon - Send Email Confirmation"
      viewBox="0 0 16.001 16"
    >
      <path
        fill="currentColor"
        d="M13.75-13.8l-13 7.5a1.5 1.5 0 00.178 2.684L4.5-2.138V.5a1.5 1.5 0 002.706.894L8.575-.453l3.5 1.444a1.516 1.516 0 00.572.112 1.5 1.5 0 00.738-.194 1.51 1.51 0 00.747-1.078l1.856-12.1A1.5 1.5 0 0013.75-13.8zM6 .5v-2.019l1.144.472zm6.644-.9L7.837-2.381 12.219-8.7a.5.5 0 00-.741-.663L4.869-3.606 1.5-5l13-7.5z"
        data-name="Path 10614"
        transform="translate(-.001 13.999)"
      ></path>
    </svg>
  );
}

export default SendEmailConfirmationIcon;
